import axios from '../_utils/axios';
import store, { persistor, DELETE_LOADER } from '../../store';

// ----------------------------------------------------------------------

const logout = async (data: object, href?: string) => {
  return await axios.post('auth/logout', data)
    .catch(() => {})
    .finally(() => {
      persistor.purge();
      if ( href ) return window.location.href = href;
      window.location.href = '/';
    });
};

export default logout;